import React, { Component } from "react";
import PropTypes from "prop-types";
import { Input } from "arv-reactcomponents";

class PAYUForm extends Component {
  componentDidMount() {
    const form = document.querySelector(
      `#paymentform-${this.props.componentName}`,
    );
    form.submit();
  }

  render() {
    const { transactions: { banking } } = this.props.formData;
    return (
      <form
        id={`paymentform-${this.props.componentName}`}
        method="post"
        action={`${banking.requestURL}`}
      >
        <div>
          {" "}
          {banking.requestParameters &&
            banking.requestParameters.map(paymentInfo => (
              <Input
                type="hidden"
                name={paymentInfo.info.pgPName}
                value={paymentInfo.info.pgPValue}
              />
            ))}
        </div>
      </form>
    );
  }
}

PAYUForm.propTypes = {
  formData: PropTypes.shape({
    transactions: PropTypes.shape({
      banking: PropTypes.shape({}),
    }),
  }),
  componentName: PropTypes.string,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: PAYUForm,
  component: PAYUForm,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentGateway/PAYUForm/index.js